import { render, staticRenderFns } from "./SearchedProducts.vue?vue&type=template&id=42142b92&scoped=true"
import script from "./SearchedProducts.vue?vue&type=script&lang=js"
export * from "./SearchedProducts.vue?vue&type=script&lang=js"
import style0 from "./SearchedProducts.vue?vue&type=style&index=0&id=42142b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42142b92",
  null
  
)

export default component.exports